<div class="attachments-container">

  <!-- Breadcrumb -->
  <div class="breadcrumb">
    <ng-container *ngFor="let crumb of breadcrumb; let i = index">
      <span class="crumb"
            (click)="navigateToBreadcrumb(crumb, i)"
            [class.clickable]="crumb.id !== null">
        {{ crumb.name }}
      </span>
      <span *ngIf="i < breadcrumb.length - 1"> / </span>
    </ng-container>
  </div>

  <!-- Upload Bar -->
  <div class="attachments-toolbar">
    <input type="file" #fileInput (change)="onFileSelected($event)" hidden />
    <button *ngIf="!selectedFile"
            class="toolbar-btn primary plus-btn"
            (click)="openFileDialog()">
      Add A File
    </button>

    <ng-container *ngIf="selectedFile">
      <span class="file-name">
        {{ selectedFile.name }}
      </span>

      <!-- Description input -->
      <div class="input-group">
        <label for="description">Description:</label>
        <input id="description" [(ngModel)]="description" type="text" placeholder="Enter description (optional)" />
      </div>

      <button class="toolbar-btn primary" (click)="upload()">
        Upload
      </button>

      <button class="toolbar-btn secondary" (click)="cancelSelection()">
        Cancel
      </button>
    </ng-container>
  </div>
  <!-- Child Folders -->
  <div class="folder-list" *ngIf="currentChildFolders.length > 0">
    <div class="folder-item"
         *ngFor="let folder of currentChildFolders"
         (click)="openFolder(folder)"
         [class.inactive-folder]="isFolderInactive(folder)">
      📁 {{ folder.folderName }}
    </div>
  </div>

  <!-- Attachments Table (only for selected folder) -->
  <div class="attachments-table" *ngIf="getAttachmentsForCurrentFolder().length > 0">
    <div class="table-header">
      <div>Name</div>
      <!--<div>Size</div>-->
      <div>Date</div>
      <div>Actions</div>
    </div>

    <div class="table-row" *ngFor="let att of getAttachmentsForCurrentFolder()">
      <div>{{ att.fileName }}</div>
      <!--<div>{{ formatBytes(att.fileSizeBytes || 0) }}</div>-->
      <div>{{ att.effectiveDate | date:'short' }}</div>
      <div class="actions">
        <button class="toolbar-btn secondary" (click)="download(att)">Download</button>
        <button class="toolbar-btn danger" (click)="delete(att)">Delete</button>
      </div>
    </div>
  </div>

  <!-- Empty State -->
  <div *ngIf="getAttachmentsForCurrentFolder().length === 0 && currentChildFolders.length === 0" class="empty">
    No folders or attachments found
  </div>
</div>
